import { FormEvent, useState } from 'react';
import { site } from '../content/site';
import './ContactSection.css';

/**
 * Contact section. Direct-link options first (email + LinkedIn) since they're
 * the highest-friction-saving for the reader. Optional form below — purely
 * client-side; submitting opens the user's mail client with the message
 * pre-filled. Swap the handler for a real endpoint when you have one.
 */
export default function ContactSection() {
  const { contact } = site;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const subject = encodeURIComponent(`Portfolio enquiry from ${name || 'a visitor'}`);
    const body = encodeURIComponent(
      `${message}\n\n— ${name || ''}${email ? `\n${email}` : ''}`
    );
    window.location.href = `mailto:${contact.email}?subject=${subject}&body=${body}`;
  }

  return (
    <section
      id="contact"
      className="contact section"
      aria-labelledby="contact-heading"
    >
      <div className="container contact__inner">
        <div className="contact__intro">
          <span className="eyebrow">{contact.eyebrow}</span>
          <h2 id="contact-heading" className="contact__heading display">
            {contact.headline}
          </h2>
          <p className="contact__sub">{contact.intro}</p>

          <div className="contact__direct">
            <a className="contact__direct-link" href={`mailto:${contact.email}`}>
              <span className="contact__direct-label">Email</span>
              <span className="contact__direct-value">{contact.email}</span>
            </a>
            <a
              className="contact__direct-link"
              href={contact.linkedin}
              target="_blank"
              rel="noreferrer noopener"
            >
              <span className="contact__direct-label">LinkedIn</span>
              <span className="contact__direct-value">View profile ↗</span>
            </a>
          </div>
        </div>

        {contact.showForm && (
          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__field">
              <label htmlFor="name">Your name</label>
              <input
                id="name"
                type="text"
                autoComplete="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="contact__field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="contact__field">
              <label htmlFor="message">What can I help with?</label>
              <textarea
                id="message"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn--primary contact__submit">
              Send message
            </button>
            <p className="contact__note">
              Submitting opens your mail client. Want a backed form?{' '}
              <a href={`mailto:${contact.email}`}>Email me directly</a>.
            </p>
          </form>
        )}
      </div>
    </section>
  );
}
